import { render } from "./VentaS.vue?vue&type=template&id=22671974&scoped=true"
import script from "./VentaS.vue?vue&type=script&lang=js"
export * from "./VentaS.vue?vue&type=script&lang=js"

import "./VentaS.vue?vue&type=style&index=0&id=22671974&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22671974"]])

export default __exports__